var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrowthGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "growth-graph",
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.036,
    height: 50.183,
    viewBox: "0 0 53.036 50.183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_87662",
    "data-name": "Path 87662",
    d: "M.5,26.75a1.981,1.981,0,0,0,1.989,1.989H8.676a2.349,2.349,0,0,0,1.768-1.989V21.889A1.981,1.981,0,0,0,8.455,19.9H2.489A1.981,1.981,0,0,0,.5,21.889Z",
    transform: "translate(-0.5 21.444)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87663",
    "data-name": "Path 87663",
    d: "M15.076,32.269a1.981,1.981,0,0,0,1.989-1.989V18.789A1.981,1.981,0,0,0,15.076,16.8H8.889A1.981,1.981,0,0,0,6.9,18.789V30.5A1.981,1.981,0,0,0,8.889,32.49h6.188Z",
    transform: "translate(7.243 17.693)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87664",
    "data-name": "Path 87664",
    d: "M15.389,35.777h6.188a1.981,1.981,0,0,0,1.989-1.989v-17.9A1.981,1.981,0,0,0,21.576,13.9H15.389A1.981,1.981,0,0,0,13.4,15.889V34.01A2.349,2.349,0,0,0,15.389,35.777Z",
    transform: "translate(15.107 14.185)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87665",
    "data-name": "Path 87665",
    d: "M30.065,10.989A1.981,1.981,0,0,0,28.076,9H21.889A1.981,1.981,0,0,0,19.9,10.989V39.717a1.981,1.981,0,0,0,1.989,1.989h6.188a1.981,1.981,0,0,0,1.989-1.989Z",
    transform: "translate(22.971 8.257)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87666",
    "data-name": "Path 87666",
    d: "M42.74,11.376a1.624,1.624,0,0,0,1.326.442,1.329,1.329,0,0,0,.884-.221A2.123,2.123,0,0,0,46.5,9.608l.442-5.967a2.8,2.8,0,0,0-.884-1.989,2.033,2.033,0,0,0-2.21-.221L38.32,3.421A2.447,2.447,0,0,0,36.773,5.41a2.1,2.1,0,0,0,.884,2.21l.884.663C31.028,17.122,16.885,26.845,4.51,26.845a2.21,2.21,0,0,0,0,4.42c13.922,0,29.391-10.607,37.567-20.552Z",
    transform: "translate(1.678 -1.191)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthGraph);
export default __webpack_public_path__ + "static/media/growthGraph.b286f123b82ed15216071638fc7bdc22.svg";
export { ForwardRef as ReactComponent };